/**
 * BUBBLE PRICE BUTTON V16
 * Affiche le prix sur le bouton "Ajouter au panier".
 * - Bundle Koala présent → prix du palier sélectionné
 * - Sinon → prix variante × quantité (cible le sélecteur du PRODUIT PRINCIPAL,
 *   en ignorant les sélecteurs résiduels d'autres produits présents dans le DOM).
 * Réapplique après réécriture du thème, respecte la rupture de stock.
 */
(function() {
  'use strict';

  let productCache = null;
  let applying = false;

  async function fetchProduct() {
    if (productCache) return productCache;
    const handle = window.location.pathname.match(/\/products\/([^\/?#]+)/)?.[1];
    if (!handle) return null;
    try {
      const r = await fetch(`/products/${handle}.js`);
      productCache = await r.json();
      return productCache;
    } catch (e) { return null; }
  }

  function formatMoney(c) {
    return c == null ? '' : `€${(c / 100).toFixed(2).replace('.', ',')}`;
  }

  function getAddButton() {
    return document.querySelector('product-form button[name="add"]');
  }
  function getMainForm() {
    return document.querySelector('product-form form[action*="/cart/add"]');
  }
  function hasKoala() {
    return !!document.querySelector('koala-quantity-breaks-embed .koala-deal__tier__input');
  }

  function koalaPrice() {
    const c = document.querySelector('.koala-deal__tier__input:checked');
    if (!c) return null;
    const t = c.closest('.koala-deal__tiers__list-item');
    const p = t && t.querySelector('.koala-deal__tier__price');
    return p ? (p.textContent.trim() || null) : null;
  }

  // L'input quantité du PRODUIT PRINCIPAL uniquement
  // (les résidus d'autres produits — ex. l'Éponge dans le panier — n'ont pas d'attribut `form`)
  function getQtyInput() {
    const mainForm = getMainForm();
    // 1) Input lié au formulaire produit principal
    if (mainForm && mainForm.id) {
      const byForm = document.querySelector('input[name="quantity"][form="' + mainForm.id + '"]');
      if (byForm) return byForm;
    }
    // 2) Fallback : input quantité visible QUI A un attribut form (élimine les résidus sans form)
    const withForm = Array.from(document.querySelectorAll('quantity-selector input[name="quantity"][form]'))
      .find(el => el.offsetParent !== null);
    if (withForm) return withForm;
    // 3) Dernier recours : input dans la zone produit principale
    const main = document.querySelector('main-product, [data-section-id]') || document;
    return main.querySelector('quantity-selector input[name="quantity"]');
  }

  function getQty() {
    const q = getQtyInput();
    if (!q) return 1;
    let n = parseInt(q.value, 10);
    if (!n || n < 1) n = 1;
    return n;
  }

  async function priceText() {
    // Priorité au bundle Koala
    if (hasKoala()) {
      const k = koalaPrice();
      if (k) return k;
    }
    // Sinon variante × quantité
    const p = await fetchProduct();
    if (!p?.variants) return null;
    const vi = document.querySelector('product-form input[name="id"]');
    const vid = vi?.value;
    let cents;
    if (!vid) {
      cents = p.variants[0]?.price ?? p.price;
    } else {
      const v = p.variants.find(x => String(x.id) === String(vid));
      cents = v ? v.price : p.price;
    }
    return formatMoney(cents * getQty());
  }

  async function apply() {
    const btn = getAddButton();
    if (!btn || btn.disabled || btn.hasAttribute('disabled')) return;
    const txt = btn.querySelector('.btn--text');
    if (!txt) return;
    // Ne pas écraser un message d'indisponibilité du thème
    const cur = txt.textContent.trim().toLowerCase();
    if (cur.includes('rupture') || cur.includes('épuisé') || cur.includes('indisponible')) return;

    const pt = await priceText();
    if (!pt) return;
    const want = `+ Ajouter au panier · ${pt}`;
    if (txt.textContent.trim() !== want) {
      applying = true;
      txt.textContent = want;
      setTimeout(() => { applying = false; }, 0);
    }
  }

  let timer = null;
  function update() { clearTimeout(timer); timer = setTimeout(apply, 40); }

  function init() {
    fetchProduct().then(update);
    setTimeout(update, 800);

    // Réapplique le prix après chaque réécriture du bouton par le thème
    const btn = getAddButton();
    const txt = btn && btn.querySelector('.btn--text');
    if (txt) {
      new MutationObserver(() => { if (!applying) update(); })
        .observe(txt, { childList: true, characterData: true, subtree: true });
    }

    // Clic sur les boutons +/− du sélecteur principal
    document.addEventListener('click', (e) => {
      if (e.target?.closest?.('quantity-selector')) {
        update(); setTimeout(update, 60); setTimeout(update, 200);
      }
      if (e.target?.closest?.('koala-quantity-breaks-embed')) update();
    });

    // Frappe / changement dans le champ quantité
    document.addEventListener('input', (e) => {
      if (e.target?.name === 'quantity') update();
    });
    document.addEventListener('change', (e) => {
      if (e.target?.name === 'quantity') update();
      if (e.target?.classList?.contains('koala-deal__tier__input')) update();
      if (e.target?.name === 'id') { productCache = null; update(); }
    });

    // Observer sur l'input quantité principal (capte les changements de value en JS)
    const q = getQtyInput();
    if (q) {
      new MutationObserver(update).observe(q, { attributes: true });
      // Polling léger de secours (lit toujours le bon input via getQtyInput)
      let last = q.value;
      setInterval(() => {
        const cur = getQtyInput();
        if (cur && cur.value !== last) { last = cur.value; update(); }
      }, 350);
    }

    console.log('✅ BubblePriceButton V16 initialisé');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();